import urlJoin from 'url-join';

import { Locale } from '@/constants/locale';

export function buildPageUrl(pathname: string, locale: Locale) {
	const localePath = locale === Locale.Ru ? '' : locale;
	const path = pathname === '/' ? '' : pathname.trim().replace(/(\/+)$/g, '');
	return `/${urlJoin(localePath, path)}`;
}
